export var EntityType;
(function (EntityType) {
    EntityType[EntityType["Ship"] = 0] = "Ship";
    EntityType[EntityType["Asteroid"] = 1] = "Asteroid";
    EntityType[EntityType["Projectile"] = 2] = "Projectile";
    EntityType[EntityType["Planet"] = 3] = "Planet";
    EntityType[EntityType["Star"] = 4] = "Star";
    EntityType[EntityType["Station"] = 5] = "Station";
    EntityType[EntityType["WarpGate"] = 6] = "WarpGate";
    EntityType[EntityType["Comet"] = 7] = "Comet";
    EntityType[EntityType["Derelict"] = 8] = "Derelict";
    EntityType[EntityType["Anomaly"] = 9] = "Anomaly";
    EntityType[EntityType["Nebula"] = 10] = "Nebula";
    EntityType[EntityType["ResourceDrop"] = 11] = "ResourceDrop";
    EntityType[EntityType["NPC"] = 12] = "NPC";
    EntityType[EntityType["Missile"] = 13] = "Missile";
})(EntityType || (EntityType = {}));
export var RaceId;
(function (RaceId) {
    RaceId[RaceId["Terran"] = 0] = "Terran";
    RaceId[RaceId["Zyrkath"] = 1] = "Zyrkath";
    RaceId[RaceId["Luminara"] = 2] = "Luminara";
    RaceId[RaceId["Vokren"] = 3] = "Vokren";
    RaceId[RaceId["ObsidianCollective"] = 4] = "ObsidianCollective";
    RaceId[RaceId["VoidWalker"] = 5] = "VoidWalker";
    // ─── Frontier civilizations (appear in deeper sectors) ───
    RaceId[RaceId["Sylphari"] = 6] = "Sylphari";
    RaceId[RaceId["KrelgHegemony"] = 7] = "KrelgHegemony";
    RaceId[RaceId["TharixCabal"] = 8] = "TharixCabal";
    RaceId[RaceId["ChronosSeers"] = 9] = "ChronosSeers";
    RaceId[RaceId["NovaForgers"] = 10] = "NovaForgers";
    RaceId[RaceId["AbyssalChorus"] = 11] = "AbyssalChorus";
    // ─── Apex civilizations (only the deep tiers — Abyss / Nightmare / Apex
    // and beyond). Locked to high player levels and dropped into the spawn
    // table by `pickRaceWithDepthBias` only at deep-sector distances; the
    // characters in this band are designed to feel like end-game content,
    // each anchoring a different deep-tier flavour. ───
    RaceId[RaceId["EidolonConclave"] = 12] = "EidolonConclave";
    RaceId[RaceId["AstralLeviathan"] = 13] = "AstralLeviathan";
    RaceId[RaceId["SingularitySovereign"] = 14] = "SingularitySovereign";
})(RaceId || (RaceId = {}));
export var ShipClass;
(function (ShipClass) {
    ShipClass[ShipClass["Scout"] = 0] = "Scout";
    ShipClass[ShipClass["Fighter"] = 1] = "Fighter";
    ShipClass[ShipClass["Interceptor"] = 2] = "Interceptor";
    ShipClass[ShipClass["Cruiser"] = 3] = "Cruiser";
    ShipClass[ShipClass["Freighter"] = 4] = "Freighter";
    ShipClass[ShipClass["Destroyer"] = 5] = "Destroyer";
    ShipClass[ShipClass["Mothership"] = 6] = "Mothership";
})(ShipClass || (ShipClass = {}));
export var ShieldType;
(function (ShieldType) {
    ShieldType[ShieldType["Energy"] = 0] = "Energy";
    ShieldType[ShieldType["Plating"] = 1] = "Plating";
    ShieldType[ShieldType["Phase"] = 2] = "Phase";
})(ShieldType || (ShieldType = {}));
export var ResourceTier;
(function (ResourceTier) {
    // ─── Core tier (existing, always compatible) ───
    ResourceTier[ResourceTier["ScrapMetal"] = 0] = "ScrapMetal";
    ResourceTier[ResourceTier["CrystalShards"] = 1] = "CrystalShards";
    ResourceTier[ResourceTier["PlasmaCore"] = 2] = "PlasmaCore";
    ResourceTier[ResourceTier["VoidEssence"] = 3] = "VoidEssence";
    ResourceTier[ResourceTier["DarkMatter"] = 4] = "DarkMatter";
    ResourceTier[ResourceTier["QuantumFragment"] = 5] = "QuantumFragment";
    // ─── Extended material tiers ───
    // Common rim metals (spawn near origin)
    ResourceTier[ResourceTier["IronOre"] = 6] = "IronOre";
    ResourceTier[ResourceTier["CopperOre"] = 7] = "CopperOre";
    ResourceTier[ResourceTier["Silicate"] = 8] = "Silicate";
    // Mid-range specialised crystals / alloys
    ResourceTier[ResourceTier["TitaniumAlloy"] = 9] = "TitaniumAlloy";
    ResourceTier[ResourceTier["SolarPlasma"] = 10] = "SolarPlasma";
    ResourceTier[ResourceTier["Bioflux"] = 11] = "Bioflux";
    ResourceTier[ResourceTier["NeutroniumDust"] = 12] = "NeutroniumDust";
    // Rare deep-space exotics
    ResourceTier[ResourceTier["ChronoQuartz"] = 13] = "ChronoQuartz";
    ResourceTier[ResourceTier["VoidPearl"] = 14] = "VoidPearl";
    ResourceTier[ResourceTier["PhasePrism"] = 15] = "PhasePrism";
    // Extreme rarity — only in the deep void
    ResourceTier[ResourceTier["StarforgeIngot"] = 16] = "StarforgeIngot";
    ResourceTier[ResourceTier["EchoCrystal"] = 17] = "EchoCrystal";
    ResourceTier[ResourceTier["SingularityShard"] = 18] = "SingularityShard";
    ResourceTier[ResourceTier["AbyssalTear"] = 19] = "AbyssalTear";
    ResourceTier[ResourceTier["EtherealEssence"] = 20] = "EtherealEssence";
    // ─── Surface fauna drops (Phase 3.1) ───
    // OrganicMatter is the common drop from every fauna kind; consumed
    // by Refinery crafting recipes for biome-flavoured gear. Sells at
    // a low base rate, so the play loop is "kill a swarm, sell or
    // craft" — not "farm for credits."
    ResourceTier[ResourceTier["OrganicMatter"] = 21] = "OrganicMatter";
})(ResourceTier || (ResourceTier = {}));
export var AsteroidSize;
(function (AsteroidSize) {
    AsteroidSize[AsteroidSize["Small"] = 0] = "Small";
    AsteroidSize[AsteroidSize["Medium"] = 1] = "Medium";
    AsteroidSize[AsteroidSize["Large"] = 2] = "Large";
    AsteroidSize[AsteroidSize["Huge"] = 3] = "Huge";
})(AsteroidSize || (AsteroidSize = {}));
export var StationService;
(function (StationService) {
    StationService[StationService["Shop"] = 0] = "Shop";
    StationService[StationService["Repair"] = 1] = "Repair";
    StationService[StationService["Crafting"] = 2] = "Crafting";
    StationService[StationService["Missions"] = 3] = "Missions";
    StationService[StationService["Hangar"] = 4] = "Hangar";
    StationService[StationService["Marketplace"] = 5] = "Marketplace";
})(StationService || (StationService = {}));
export var NPCDisposition;
(function (NPCDisposition) {
    NPCDisposition[NPCDisposition["Hostile"] = 0] = "Hostile";
    NPCDisposition[NPCDisposition["Neutral"] = 1] = "Neutral";
    NPCDisposition[NPCDisposition["Friendly"] = 2] = "Friendly";
    NPCDisposition[NPCDisposition["Merchant"] = 3] = "Merchant";
})(NPCDisposition || (NPCDisposition = {}));
//# sourceMappingURL=entities.js.map